import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
import useMobile from "@/hooks/use-mobile";

// Composant pour afficher une carte de club
export default function CreateClubCard() {
  const $ = _c(5);
  const isMobile = useMobile();
  const t0 = `w-[380px] ${isMobile ? "" : "px-2"} pt-3 pr-3 pb-8  relative`;
  let t1;
  if ($[0] !== t0) {
    t1 = twMerge(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/creer-un-club"><div className="flex flex-col justify-center gap-4 items-center relative p-4 rounded-[20px] shadow-[0_0_5px_rgba(0,0,0,0.2)] h-[350px] bg-primary cursor-pointer transition-all duration-300 ease-in-out hover:shadow-[0_4px_15px_rgba(0,0,0,0.2)] hover:scale-[1.01]"><Image src="/img/idea-bulb.png" alt="Create Club" width={100} height={100} /><p className="text-white text-2xl text-center">Vous ne trouvez pas votre bonheur ?</p><p className="text-white font-bold text-2xl">Créez votre Club d'Affaires !</p><div className="text-primary bg-white rounded-full px-4 py-2 font-bold">En savoir plus</div></div></Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={t1}>{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}